<div class="not-found">
  <img src="assets/work-from-home.png" alt="https://www.flaticon.com/free-icons/computer" height="512" width="512" class="image" priority>
  <!--<a href="https://www.flaticon.com/free-icons/computer" title="computer icons">Computer icons created by amonrat rungreangfangsai - Flaticon</a>-->
  <h1>{{'SOMETHING_WENT_WRONG' | translate}}</h1>
  <h3 class="error-message">{{errorMessage}}</h3>
  <h2>{{'RETURN_TO_DASHBOARD' | translate}}</h2>
  <button mat-raised-button (click)="backToPage()">{{'YES' | translate}}</button>
</div>
